import { IAttachment } from '../Application/types';
import { AttachmentType } from '../Application/config';

/*
  Determines the type of attachment based on the attached_content_type of the asset
  @param selectedAttachment: IAttachment
  @returns { isImage: boolean, isVideo: boolean, isAudio: boolean, isText: boolean, isPdf: boolean, isWord: boolean }
 */
export const getAttachmentType = (selectedAttachment: IAttachment): AttachmentType | undefined => {
  const contentType = selectedAttachment?.attached_content_type;
  if (!contentType) return;

  const typeMap: Record<string, AttachmentType> = {
    image: AttachmentType.Image,
    video: AttachmentType.Video,
    audio: AttachmentType.Audio,
    'text/plain': AttachmentType.Text,
    'application/pdf': AttachmentType.Pdf,
    'application/msword': AttachmentType.Word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': AttachmentType.Word
  };

  const typePrefix = contentType.split('/')[0];
  const typeFull = contentType;

  return typeMap[typeFull] || typeMap[typePrefix];
};
